export default "__VITE_ASSET__3a6681ad__"